<nav class="navbar main-navbar navbar-expand-sm navbar-toggleable-sm navbar-light bg-white border-bottom box-shadow pt-3 pb-5">
  <div class="container">
    <a class="navbar-brand" [routerLink]="['/']">
      <img src="/assets/images/logo-default.svg" alt="Secure Choice Lending" class="logo-img">
    </a>
    <app-external-main-nav-menu></app-external-main-nav-menu>
    <app-external-profile-nav-menu class="ml-5"></app-external-profile-nav-menu>
  </div>
</nav>
<app-second-nav-menu></app-second-nav-menu>
